
import { useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'

import { QUERY_KEYS } from '@/modules/shared/constants/query-keys.contant'
import { useResolveRequestHook } from '@/modules/shared/hooks/use-resolve-request.hook'

import { SEARCH_ENTITY_PARAMS } from '../components/details/selection-modal/entity-selection.constants'
import { useOrderFormStore } from '../stores/order-form.store'
import { useReplicateOrderMutation } from '../mutations/replicate-order-mutation'
import { useClientInfiniteSearch } from './use-client-infinite-search.hook'
import { useOrdersSearchStore } from '../stores/order-search.store'

type Props = {
  onClose: () => void
}

export const useModalOrderReplicateComponent = ({ onClose }: Props) => {
  const [clientSelectedToReplicate, setCustomerSelectedToReplicate] = useState<number[]>([])
  const [replicateOrderDiscount, setReplicateOrderDiscount] = useState(false)

  const { checkStatusOnRequest } = useResolveRequestHook()
  const { orderSelected } = useOrderFormStore()

  const {
    actions: { setFilters },
  } = useOrdersSearchStore()

  const queryClient = useQueryClient()

  const clientSearch = useClientInfiniteSearch()

  const { replicateOrderRequest, isLoadingReplicateOrder } = useReplicateOrderMutation({
    callback: async () => {
      await queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.ORDERS],
        exact: true,
        refetchType: 'active',
      })

      queryClient.removeQueries({
        queryKey: ['orderForm', 'new'],
      })

      setFilters(undefined)
    },
    resolveRequest: checkStatusOnRequest,
  })

  const handleCloseModal = () => {
    onClose()
    setCustomerSelectedToReplicate([])
    setReplicateOrderDiscount(false)
    clientSearch.resetSearch()
  }

  const handleSearchClient = clientSearch.searchClients

  const handleSelectClientToReplicate = (clientId: number) => {
    const hasClientSelected = clientSelectedToReplicate.includes(clientId)

    if (hasClientSelected) {
      setCustomerSelectedToReplicate((prevState) =>
        prevState.filter((id) => id !== clientId),
      )
      return
    }

    setCustomerSelectedToReplicate((prevState) => prevState.concat(clientId))
  }

  const handleToggleOrderDiscount = () => {
    setReplicateOrderDiscount((prevState) => !prevState)
  }

  const handleSubmitOrderReplicate = async () => {
    if (clientSelectedToReplicate.length === 0) return

    await replicateOrderRequest({
      payload: {
        orderId: String(orderSelected.idPedidoCel),
        clientsId: clientSelectedToReplicate,
        replicaDesconto: replicateOrderDiscount,
        dispositivo: orderSelected.fkUsuarioxDispositivo,
      },
    })

    handleCloseModal()
  }

  return {
    // Estados da busca infinita
    clients: clientSearch.clients,
    isLoadingRequestClientToReplicate: clientSearch.isLoading,
    isLoadingMore: clientSearch.isLoadingMore,
    hasMore: clientSearch.hasMore,
    totalRecords: clientSearch.totalRecords,

    // Estados locais
    clientSelectedToReplicate,
    replicateOrderDiscount,
    isLoadingReplicateOrder,

    // Constantes
    filterSearchEntity: SEARCH_ENTITY_PARAMS,

    // Métodos da busca infinita
    loadMore: clientSearch.loadMore,

    // Métodos locais
    handleSearchClient,
    handleSubmitOrderReplicate,
    handleSelectClientToReplicate,
    handleToggleOrderDiscount,
    handleCloseModal,
  }
}